import ReactDOM from 'react-dom/client';
// import prefetchPage from '@@/utils/prefetchPage';
import React from 'react';
import * as Sentry from '@sentry/react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';

import * as serviceWorkerRegistration from './src/serviceWorkerRegistration';
import reportWebVitals from './src/reportWebVitals';

Sentry.init({
  // debug: true,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  dsn: 'https://8361421aaccd75720a918133bfac3b2b@o4508659939082240.ingest.us.sentry.io/4509084781707264',
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById('root'));

// Función para obtener el subdominio de la URL actual
const getSubdomain = () => {
  const { hostname } = window.location;
  const parts = hostname.split('.');
  const lenghtHost = import.meta.MODE === 'production' ? 2 : 1;
  if (parts.length > lenghtHost) return parts[0];
  return null; // Sin subdominio
};

// Función para validar el tenant
const validateTenant = async () => {
  const subdomain = getSubdomain();
  if (!subdomain) return false;

  const response = await fetch(
    `${import.meta.env.VITE_API_URL}/api/comprobar_tenant?inquilino=${subdomain}&id=${subdomain}`
    // {
    //   cache: 'force-cache',
    // }
  );
  if (!response.ok) {
    throw new Error('Error al validar el tenant');
  }
  const data = await response.json();
  return data; // Se asume que el API devuelve algo como { valid: true }
};

// Inicializar la app
const initializeApp = async () => {
  try {
    const isValid = await validateTenant();
    if (isValid) {
      const { default: App } = await import('./src/App');
      root.render(<App />);
    } else {
      const { default: HomeApp } = await import('./home/HomeApp');
      root.render(<HomeApp />);
    }
  } catch (error) {
    console.error('Error al inicializar la aplicación:', error);
    root.render(<h1>La Facturacion Digital esta en descanso.</h1>);
  }
};

// Llamar la función de inicialización
initializeApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
